import * as React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import MDInput from "components/MDInput";
import { useState } from "react";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";
import swal from "sweetalert";
import SalesTable from "examples/Tables/SalesTable";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { updateCompany } from "rest/requests";
import { createCompany } from "rest/requests";

function deleteLab(lab, setLabs) {
  setLabs((labs) => {
    return labs.filter((_lab) => {
      return _lab.code !== lab.code;
    });
  });
}

function editLabCode(newCode, lab, setLabs) {
  setLabs((labs) => {
    return labs.filter((_lab) => {
      if (_lab.code === lab.code) {
        _lab["code"] = newCode;
      }
      return _lab;
    });
  });
}

function editLabName(newName, lab, setLabs) {
  setLabs((labs) => {
    return labs.filter((_lab) => {
      if (_lab.code === lab.code) {
        _lab["name"] = newName;
      }
      return _lab;
    });
  });
}

function addNewLab(setLabs) {
  setLabs((labs) => {
    return [...labs, ...[{ code: "", name: "" }]];
  });
}

function showLabs(labs, setLabs) {
  return labs.map((lab, index) => {
    return {
      Codigo: (
        <MDInput
          key={"code" + index}
          value={lab.code}
          size="small"
          disabled={false}
          type="text"
          onChange={(event) => editLabCode(event.target.value, lab, setLabs)}
          autoFocus
        ></MDInput>
      ),
      Name: (
        <MDInput
          key={"name" + index}
          value={lab.name}
          size="small"
          disabled={false}
          type="text"
          onChange={(event) => editLabName(event.target.value, lab, setLabs)}
          autoFocus
        ></MDInput>
      ),
      Acciones: (
        <MDButton
          key={"button" + index}
          variant="text"
          size="medium"
          color="secondary"
          iconOnly
          onClick={() => deleteLab(lab, setLabs)}
        >
          <DeleteIcon color="primary" />
        </MDButton>
      ),
    };
  });
}

function editCompany(company, code, name, representative, telephone, labs, setIsEditingCompany) {
  console.log("Editing...");
  const body = {
    id: company.id,
    name: name,
    code: code,
    representative: representative,
    telephone: telephone,
    laboratories: labs,
  };
  updateCompany(company.id, body)
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Compañia actualizada exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating Company: ", error);
    });
  setIsEditingCompany(false);
}

function addCompany(code, name, representative, telephone, labs, setIsEditingCompany) {
  const body = {
    name: name,
    code: code,
    representative: representative,
    telephone: telephone,
    laboratories: labs,
  };
  createCompany(body)
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Compañia creada exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error creating Company: ", error);
    });
  setIsEditingCompany(false);
}

function EditCompany({ companyToEdit, setIsEditingCompany }) {
  const [code, setCode] = useState(companyToEdit ? companyToEdit.code : "");
  const [name, setName] = useState(companyToEdit ? companyToEdit.name : "");
  const [representative, setRepresentative] = useState(
    companyToEdit ? companyToEdit.representative : ""
  );
  const [telephone, setTelephone] = useState(companyToEdit ? companyToEdit.telephone : "");

  const _labs = companyToEdit && "laboratories" in companyToEdit ? companyToEdit.laboratories : [];
  const [labs, setLabs] = useState(_labs);

  return (
    <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
      <Grid container marginTop={2}>
        <Grid item sm={6} xs={12}>
          <MDInput
            variant="outlined"
            type="text"
            label="Codigo"
            value={code}
            fullWidth={true}
            onChange={(event) => setCode(event.target.value)}
            success={code != ""}
            error={code === ""}
          />
        </Grid>
      </Grid>

      <Grid container marginTop={2}>
        <Grid item sm={6} xs={12}>
          <MDInput
            variant="outlined"
            type="text"
            label="Nombre"
            value={name}
            fullWidth={true}
            onChange={(event) => setName(event.target.value)}
            success={name != ""}
            error={name === ""}
          />
        </Grid>
      </Grid>

      <Grid container marginTop={2}>
        <Grid item sm={6} xs={12}>
          <MDInput
            variant="outlined"
            type="text"
            label="Representante"
            value={representative}
            fullWidth={true}
            onChange={(event) => setRepresentative(event.target.value)}
            success={representative != ""}
            error={representative === ""}
          />
        </Grid>
      </Grid>

      <Grid container marginTop={2}>
        <Grid item sm={6} xs={12}>
          <MDInput
            variant="outlined"
            type="text"
            label="Teléfono"
            value={telephone}
            fullWidth={true}
            onChange={(event) => setTelephone(event.target.value)}
            success={telephone != ""}
            error={telephone === ""}
          />
        </Grid>
      </Grid>

      <Divider></Divider>

      <Grid container marginTop={2}>
        <Grid item sm={6}>
          <MDBox
            bgColor="light"
            variant="contained"
            borderRadius="lg"
            shadow="lg"
            opacity={1}
            p={1}
          >
            <MDButton
              variant="text"
              size="small"
              color="secondary"
              onClick={() => addNewLab(setLabs)}
            >
              <AddIcon></AddIcon>
              Adicionar Laboratorio
            </MDButton>
            <SalesTable title="Laboratorios" rows={showLabs(labs, setLabs)} />
          </MDBox>
        </Grid>
      </Grid>

      <Divider></Divider>
      <Grid container marginTop={2}>
        <Grid item padding={2}>
          <MDButton variant="outlined" color="info" onClick={() => setIsEditingCompany(false)}>
            Atras
          </MDButton>
        </Grid>

        <Grid item padding={2}>
          {companyToEdit ? (
            <MDButton
              variant="contained"
              color="info"
              onClick={() =>
                editCompany(
                  companyToEdit,
                  code,
                  name,
                  representative,
                  telephone,
                  labs,
                  setIsEditingCompany
                )
              }
            >
              Actualizar
            </MDButton>
          ) : (
            <MDButton
              variant="contained"
              color="info"
              onClick={() =>
                addCompany(code, name, representative, telephone, labs, setIsEditingCompany)
              }
            >
              Crear
            </MDButton>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default EditCompany;

EditCompany.defaultProps = {
  companyToEdit: null,
  setIsEditingCompany: null,
};

EditCompany.propTypes = {
  companyToEdit: PropTypes.object,
  setIsEditingCompany: PropTypes.func,
};
